import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import logo from "../assets/images/logo.png";
import { useSelector, useDispatch } from "react-redux";
import { setLogout } from "../store/actions/authAction";

const Header = () => {
  const [sidebar, setSidebar] = useState(false);
  const isAuthenticated = useSelector(state => state.auth.loggedIn);
  console.log(sidebar);
  const dispatch = useDispatch();
  const handleClick = e => {
    setSidebar(true);
  };
  const handleClickToggle = e => {
    setSidebar(false);
  };

  return (
    <>
      <header className="d-none d-lg-block">
        <div className="container">
          <div className="row justify-content-between align-items-center">
            <div className="col-lg-3">
              <img src={logo} className="img-fluid" alt="" />
            </div>
            <div className="col-lg-6">
              <div className="header-top-div">
                <div className="icon-div">
                  <i className="fab fa-facebook-f"></i>
                  <i className="fab fa-youtube"></i>
                </div>
                <div className="search-div">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                  />
                  <button>
                    <i class="fas fa-search"></i>
                  </button>
                </div>
              </div>
              <div className="buttons-div">
                <a
                  className="btn"
                  href="https://ourproject.link/kba/category/%e0%a6%86%e0%a6%ae%e0%a6%be%e0%a6%a6%e0%a7%87%e0%a6%b0-%e0%a6%95%e0%a6%a5%e0%a6%be/"
                >
                  আমাদের কথা
                </a>

                <a
                  className="btn"
                  href="https://ourproject.link/kba/%e0%a6%af%e0%a7%8b%e0%a6%97%e0%a6%be%e0%a6%af%e0%a7%8b%e0%a6%97/"
                >
                  যোগাযোগ
                </a>

                {isAuthenticated ? (
                  <button onClick={e => dispatch(setLogout())} className="btn">
                    লগ আউট
                  </button>
                ) : (
                  <Link to="/login">
                    <button className="btn">লগ ইন</button>
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Navbar */}
      <section id="main-nav" className="d-none d-lg-block">
        <nav class="nav">
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              data-bs-toggle="dropdown"
              href="#"
              role="button"
              aria-expanded="false"
            >
              ইতিবাচক রাজনীতির গল্প
            </a>
            <ul class="dropdown-menu">
              <li>
                <a
                  class="dropdown-item"
                  href="https://ourproject.link/kba/category/%e0%a6%87%e0%a6%a4%e0%a6%bf%e0%a6%ac%e0%a6%be%e0%a6%9a%e0%a6%95-%e0%a6%b0%e0%a6%be%e0%a6%9c%e0%a6%a8%e0%a7%80%e0%a6%a4%e0%a6%bf%e0%a6%b0-%e0%a6%97%e0%a6%b2%e0%a7%8d%e0%a6%aa/%e0%a6%a8%e0%a6%bf%e0%a6%ac%e0%a6%a8%e0%a7%8d%e0%a6%a7/"
                >
                  নিবন্ধ
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  href="https://ourproject.link/kba/category/%e0%a6%87%e0%a6%a4%e0%a6%bf%e0%a6%ac%e0%a6%be%e0%a6%9a%e0%a6%95-%e0%a6%b0%e0%a6%be%e0%a6%9c%e0%a6%a8%e0%a7%80%e0%a6%a4%e0%a6%bf%e0%a6%b0-%e0%a6%97%e0%a6%b2%e0%a7%8d%e0%a6%aa/%e0%a6%9b%e0%a6%ac%e0%a6%bf/"
                >
                  ছবি
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  href="https://ourproject.link/kba/category/%e0%a6%87%e0%a6%a4%e0%a6%bf%e0%a6%ac%e0%a6%be%e0%a6%9a%e0%a6%95-%e0%a6%b0%e0%a6%be%e0%a6%9c%e0%a6%a8%e0%a7%80%e0%a6%a4%e0%a6%bf%e0%a6%b0-%e0%a6%97%e0%a6%b2%e0%a7%8d%e0%a6%aa/%e0%a6%ad%e0%a6%bf%e0%a6%a1%e0%a6%bf%e0%a6%93/"
                >
                  ভিডিও
                </a>
              </li>
            </ul>
          </li>

          <li class="nav-item">
            <a
              class="nav-link"
              href="https://ourproject.link/kba/category/%e0%a6%95%e0%a6%a5%e0%a6%be-%e0%a6%b9%e0%a7%8b%e0%a6%95/"
            >
              কথা হোক
            </a>
          </li>

          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              data-bs-toggle="dropdown"
              href="https://ourproject.link/kba/category/%e0%a6%b8%e0%a6%b9%e0%a6%9c-%e0%a6%aa%e0%a6%be%e0%a6%a0/%e0%a6%a6%e0%a7%83%e0%a6%b6%e0%a7%8d%e0%a6%af-%e0%a6%97%e0%a6%b2%e0%a7%8d%e0%a6%aa-%e0%a6%b8%e0%a6%b9%e0%a6%9c-%e0%a6%aa%e0%a6%be%e0%a6%a0/"
              role="button"
              aria-expanded="false"
            >
              সহজ পাঠ
            </a>
            <ul class="dropdown-menu">
              <li>
                <a
                  class="dropdown-item"
                  href="https://ourproject.link/kba/category/%e0%a6%b8%e0%a6%b9%e0%a6%9c-%e0%a6%aa%e0%a6%be%e0%a6%a0/%e0%a6%a6%e0%a7%83%e0%a6%b6%e0%a7%8d%e0%a6%af-%e0%a6%97%e0%a6%b2%e0%a7%8d%e0%a6%aa-%e0%a6%b8%e0%a6%b9%e0%a6%9c-%e0%a6%aa%e0%a6%be%e0%a6%a0/"
                >
                  দৃশ্য গল্প
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  href="https://ourproject.link/kba/category/%e0%a6%b8%e0%a6%b9%e0%a6%9c-%e0%a6%aa%e0%a6%be%e0%a6%a0/%e0%a6%9b%e0%a6%ac%e0%a6%bf%e0%a6%b0-%e0%a6%aa%e0%a6%be%e0%a6%a0/"
                >
                  ছবির পাঠ
                </a>
              </li>
            </ul>
          </li>

          <li class="nav-item">
            <NavLink class="nav-link" to="/">
              কুইজ
            </NavLink>
          </li>

          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              data-bs-toggle="dropdown"
              href="#"
              role="button"
              aria-expanded="false"
            >
              ক্যাম্পেইন
            </a>
            <ul class="dropdown-menu">
              <li>
                <a
                  class="dropdown-item"
                  href="https://ourproject.link/kba/%e0%a6%9a%e0%a6%b2%e0%a6%ae%e0%a6%be%e0%a6%a8-%e0%a6%95%e0%a7%8d%e0%a6%af%e0%a6%be%e0%a6%ae%e0%a7%8d%e0%a6%aa%e0%a7%87%e0%a6%87%e0%a6%a8/"
                >
                  চলমান ক্যাম্পেইন
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  href="https://ourproject.link/kba/category/%e0%a6%95%e0%a7%8d%e0%a6%af%e0%a6%be%e0%a6%ae%e0%a7%8d%e0%a6%aa%e0%a7%87%e0%a6%87%e0%a6%a8/%e0%a6%86%e0%a6%b0%e0%a7%8d%e0%a6%95%e0%a6%be%e0%a6%87%e0%a6%ad-%e0%a6%95%e0%a7%8d%e0%a6%af%e0%a6%be%e0%a6%ae%e0%a7%8d%e0%a6%aa%e0%a7%87%e0%a6%87%e0%a6%a8/"
                >
                  আর্কাইভ ক্যাম্পেইন
                </a>
              </li>
            </ul>
          </li>
        </nav>
      </section>

      {/* Mobile version */}
      <section className="py-2 d-lg-none">
        <div className="container">
          <div className="col-12 text-center">
            <div
              onClick={handleClick}
              style={{ position: "relative", top: "40px" }}
            >
              <i
                class="fas fa-bars"
                style={{ position: "absolute", left: "0", fontSize: "25px" }}
              ></i>
            </div>
            <img src={logo} alt="" />
          </div>
        </div>
      </section>

      <section className={sidebar ? "mobile-menu" : "d-none"}>
        <div className="container">
          <div className="row">
            <div className="col-12 text-left">
              <button className="mb-3" onClick={handleClickToggle}>
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="col-12">
              <div className="form-box">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search"
                />
                <i className="fas fa-search"></i>
              </div>
            </div>
            <div className="col-12 text-center my-3">
              <div className="icon-div">
                <i
                  className="fab fa-facebook-f"
                  style={{ marginRight: "10px" }}
                ></i>
                <i className="fab fa-youtube"></i>
              </div>
            </div>
            <li class="nav-item dropdown">
              <a
                class=" dropdown-toggle"
                data-bs-toggle="dropdown"
                href="#"
                role="button"
                aria-expanded="false"
              >
                ইতিবাচক রাজনীতির গল্প
              </a>
              <ul class="dropdown-menu">
                <li>
                  <a
                    class="dropdown-item"
                    href="https://ourproject.link/kba/category/%e0%a6%87%e0%a6%a4%e0%a6%bf%e0%a6%ac%e0%a6%be%e0%a6%9a%e0%a6%95-%e0%a6%b0%e0%a6%be%e0%a6%9c%e0%a6%a8%e0%a7%80%e0%a6%a4%e0%a6%bf%e0%a6%b0-%e0%a6%97%e0%a6%b2%e0%a7%8d%e0%a6%aa/%e0%a6%a8%e0%a6%bf%e0%a6%ac%e0%a6%a8%e0%a7%8d%e0%a6%a7/"
                  >
                    নিবন্ধ
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    href="https://ourproject.link/kba/category/%e0%a6%87%e0%a6%a4%e0%a6%bf%e0%a6%ac%e0%a6%be%e0%a6%9a%e0%a6%95-%e0%a6%b0%e0%a6%be%e0%a6%9c%e0%a6%a8%e0%a7%80%e0%a6%a4%e0%a6%bf%e0%a6%b0-%e0%a6%97%e0%a6%b2%e0%a7%8d%e0%a6%aa/%e0%a6%9b%e0%a6%ac%e0%a6%bf/"
                  >
                    ছবি
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    href="https://ourproject.link/kba/category/%e0%a6%87%e0%a6%a4%e0%a6%bf%e0%a6%ac%e0%a6%be%e0%a6%9a%e0%a6%95-%e0%a6%b0%e0%a6%be%e0%a6%9c%e0%a6%a8%e0%a7%80%e0%a6%a4%e0%a6%bf%e0%a6%b0-%e0%a6%97%e0%a6%b2%e0%a7%8d%e0%a6%aa/%e0%a6%ad%e0%a6%bf%e0%a6%a1%e0%a6%bf%e0%a6%93/"
                  >
                    ভিডিও
                  </a>
                </li>
              </ul>
            </li>
            <li class="nav-item">
              <a
                class=""
                href="https://ourproject.link/kba/category/%e0%a6%95%e0%a6%a5%e0%a6%be-%e0%a6%b9%e0%a7%8b%e0%a6%95/"
              >
                কথা হোক
              </a>
            </li>

            <li class="nav-item dropdown">
              <a
                class=" dropdown-toggle"
                data-bs-toggle="dropdown"
                href="https://ourproject.link/kba/category/%e0%a6%b8%e0%a6%b9%e0%a6%9c-%e0%a6%aa%e0%a6%be%e0%a6%a0/%e0%a6%a6%e0%a7%83%e0%a6%b6%e0%a7%8d%e0%a6%af-%e0%a6%97%e0%a6%b2%e0%a7%8d%e0%a6%aa-%e0%a6%b8%e0%a6%b9%e0%a6%9c-%e0%a6%aa%e0%a6%be%e0%a6%a0/"
                role="button"
                aria-expanded="false"
              >
                সহজ পাঠ
              </a>
              <ul class="dropdown-menu">
                <li>
                  <a
                    class="dropdown-item"
                    href="https://ourproject.link/kba/category/%e0%a6%b8%e0%a6%b9%e0%a6%9c-%e0%a6%aa%e0%a6%be%e0%a6%a0/%e0%a6%a6%e0%a7%83%e0%a6%b6%e0%a7%8d%e0%a6%af-%e0%a6%97%e0%a6%b2%e0%a7%8d%e0%a6%aa-%e0%a6%b8%e0%a6%b9%e0%a6%9c-%e0%a6%aa%e0%a6%be%e0%a6%a0/"
                  >
                    দৃশ্য গল্প
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    href="https://ourproject.link/kba/category/%e0%a6%b8%e0%a6%b9%e0%a6%9c-%e0%a6%aa%e0%a6%be%e0%a6%a0/%e0%a6%9b%e0%a6%ac%e0%a6%bf%e0%a6%b0-%e0%a6%aa%e0%a6%be%e0%a6%a0/"
                  >
                    ছবির পাঠ
                  </a>
                </li>
              </ul>
            </li>

            <li class="nav-item">
              <NavLink class="" to="/">
                কুইজ
              </NavLink>
            </li>

            <li class="nav-item dropdown">
              <a
                class=" dropdown-toggle"
                data-bs-toggle="dropdown"
                href="#"
                role="button"
                aria-expanded="false"
              >
                ক্যাম্পেইন
              </a>
              <ul class="dropdown-menu">
                <li>
                  <a
                    class="dropdown-item"
                    href="https://ourproject.link/kba/%e0%a6%9a%e0%a6%b2%e0%a6%ae%e0%a6%be%e0%a6%a8-%e0%a6%95%e0%a7%8d%e0%a6%af%e0%a6%be%e0%a6%ae%e0%a7%8d%e0%a6%aa%e0%a7%87%e0%a6%87%e0%a6%a8/"
                  >
                    চলমান ক্যাম্পেইন
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    href="https://ourproject.link/kba/category/%e0%a6%95%e0%a7%8d%e0%a6%af%e0%a6%be%e0%a6%ae%e0%a7%8d%e0%a6%aa%e0%a7%87%e0%a6%87%e0%a6%a8/%e0%a6%86%e0%a6%b0%e0%a7%8d%e0%a6%95%e0%a6%be%e0%a6%87%e0%a6%ad-%e0%a6%95%e0%a7%8d%e0%a6%af%e0%a6%be%e0%a6%ae%e0%a7%8d%e0%a6%aa%e0%a7%87%e0%a6%87%e0%a6%a8/"
                  >
                    আর্কাইভ ক্যাম্পেইন
                  </a>
                </li>
              </ul>
            </li>
          </div>
        </div>
      </section>
    </>
  );
};

export default Header;
